function BlogMovieList({ listData }) {
  return (
    <>
      {Object.keys(listData).length &&
      listData.movie_info &&
      listData.movie_info.list &&
      listData.movie_info.list.length > 0 ? (
        <>
          {renderList(listData.movie_info)}
          <div className="m-5"></div>
        </>
      ) : (
        ""
      )}

      {Object.keys(listData).length &&
      listData.show_info &&
      listData.show_info.list &&
      listData.show_info.list.length > 0
        ? renderList(listData.show_info)
        : ""}

      {/* Array Traverse */}
      {Object.keys(listData).length &&
      listData.movie_info_arr &&
      listData.movie_info_arr.length > 0
        ? listData.movie_info_arr.map((item, indx) => {
            return (
              <div className="list-array" key={indx}>
                {renderList(item)}
              </div>
            );
          })
        : ""}
      {/* Array Traverse */}
    </>
  );
  function getDisplayTitle(item) {
    let displayTitle = item.movie_title;
    if (item.movie_display_title) {
      displayTitle = item.movie_display_title;
    }
    return displayTitle;
  }
  function getBlogLaunchUrl(item) {
    let urlFull = window.location.href;
    let url = urlFull;
    let qs = "";
    if (urlFull.indexOf("?") > -1) {
      url = urlFull.split("?")[0];
      qs = "?" + urlFull.split("?")[1];
    }
    let newUrl = url.replace(/\/#\/?$/, "");
    newUrl = window.location.protocol + "//" + window.location.hostname;
    let title = getCleanedTitle(item.movie_title);
    let nodeId = item.node_id;
    let base = "/";
    let itemType = "movies";
    if (item.itemType && item.itemType.toLowerCase() === "tv-shows") {
      itemType = "tv-shows";
    } else if (item.itemType && item.itemType.toLowerCase() === "category") {
      itemType = "category";
    } else if (item.itemType && item.itemType.toLowerCase() === "shows") {
      itemType = "shows";
    }
    //itemType = "tv-shows";
    let moviePath = `${itemType}/${nodeId}/${title}`;
    let moviePathWithSlash = base + moviePath;
    if (!newUrl.endsWith("/")) {
      moviePath = moviePathWithSlash;
    }
    let baseUrl = document.location.origin;
    //window.location.href = baseUrl + moviePath + qs;
    return baseUrl + moviePath + qs;
  }
  function getCleanedTitle(str) {
    str = str.toLowerCase().split(" ").join("-");
    /*// Replace all non-alphanumeric characters except hyphens with an empty string
		str = str.replace(/[^\w-]+/g, '-');
		// Replace consecutive hyphens with a single hyphen
		str = str.replace(/-{2,}/g, '-');
		return str;*/
    // Remove all non-alphanumeric characters except hyphens
    str = str.replace(/[^\w-]/g, "");
    // Remove consecutive hyphens
    str = str.replace(/-{2,}/g, "-");
    // Remove trailing hyphen (if present)
    str = str.replace(/-$/, "");
    return str;
  }
  function getImageUrl(item) {
    let imageUrl = `${window.cdnBaseUrl}${item.movie_image}`;
    return imageUrl;
  }
  function renderList(info) {
    return (
      <>
        <h2
          className="mb-4 list-title"
          dangerouslySetInnerHTML={{ __html: info.title }}
        />
        <div className="blogstuff-de mb-4 ">
          <div
            dangerouslySetInnerHTML={{
              __html: info.sub_title,
            }}
          />
        </div>
        {info.list.length > 0 &&
          info.list.map((item, index) => {
            return [
              index % 2 === 0 ? (
                <article className="blog-de-post" key={index}>
                  <div className="blog-de-post-container row">
                    <div className="blog-de-post-image col-md-3 col-sm-12">
                      <a
                        href={getBlogLaunchUrl(item)}
                        className="gtm-lp gtm-blog-thumbnail"
                      >
                        <img src={getImageUrl(item)} alt={item.movie_title} />
                      </a>
                    </div>
                    <div className="blog-de-post-content col-md-9 col-sm-12">
                      <div className="blog-de-post-header">
                        <h2>{getDisplayTitle(item)}</h2>
                        {item.movie_sub_title ? (
                          <h2>{item.movie_sub_title}</h2>
                        ) : (
                          ""
                        )}
                      </div>
                      <div className="blogstuff-de mb-4 ">
                        <div
                          dangerouslySetInnerHTML={{
                            __html: item.movie_description,
                          }}
                        />
                      </div>
                      <a
                        href={getBlogLaunchUrl(item)}
                        className="btn btn-primary gtm-lp gtm-blog-watch-now"
                      >
                        Watch Now
                      </a>
                      {/* &nbsp;&nbsp;
                      <div className="share-container blog-list">
                        <Share
                          url={getBlogLaunchUrl(item)}
                          msg={"Watch%20Now%20On%20Fawesome"}
                        ></Share>
                      </div> */}
                    </div>
                  </div>
                </article>
              ) : (
                <article className="blog-de-post" key={index}>
                  <div className="blog-de-post-container row">
                    <div className="blog-de-post-content col-md-9 col-sm-12">
                      <div className="blog-de-post-header">
                        <h2>{getDisplayTitle(item)}</h2>
                        {item.movie_sub_title ? (
                          <h2>{item.movie_sub_title}</h2>
                        ) : (
                          ""
                        )}
                      </div>
                      <div className="blogstuff-de mb-4 ">
                        <div
                          dangerouslySetInnerHTML={{
                            __html: item.movie_description,
                          }}
                        />
                      </div>
                      <a
                        href={getBlogLaunchUrl(item)}
                        className="btn btn-primary gtm-lp gtm-blog-watch-now"
                      >
                        Watch Now
                      </a>
                      {/* &nbsp;&nbsp;
                      <div className="share-container blog-list">
                        <Share
                          url={getBlogLaunchUrl(item)}
                          msg={"Watch%20Now%20On%20Fawesome"}
                        ></Share>
                      </div> */}
                    </div>
                    <div className="blog-de-post-image col-md-3 col-sm-12">
                      <a
                        href={getBlogLaunchUrl(item)}
                        className="gtm-lp gtm-blog-thumbnail"
                      >
                        <img src={getImageUrl(item)} alt={item.movie_title} />
                      </a>
                    </div>
                  </div>
                </article>
              ),
            ];
          })}
      </>
    );
  }
}
export default BlogMovieList;
